import React from 'react';
import App from 'components/App';

import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';  // MobX 에서 사용하는 Provider
import { RootStore } from 'stores'; // *** 루트 스토어 생성

const Root = () => {
  return (
    <Provider {...RootStore}>  {/* *** ...root 으로 스토어 모두 자동으로 설정 */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  );
}

export default Root;
